import Vue from "vue";
import Router from "vue-router";
import Authorize from "../shared/authorization/authorize";
import { getTranslation } from "../shared/language-helper";
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const PublicContainer = () => import("@/containers/PublicContainer");
// views
const Dashboard = () => import("@/views/home/Dashboard");

const OrderList = () => import("@/views/order/OrderList");
const OrderDetail = () => import("@/views/order/OrderDetail");
const OrderAdd = () => import("@/views/order/OrderAdd");

const CargoTracking = () => import("@/views/cargo/CargoTracking");
const DailyCargo = () => import("@/views/cargo/DailyCargo");

const AliMoney = () => import("@/views/alimoney/AliMoney");
const ManuelMoneyTransfer = () => import("@/views/alimoney/ManuelMoneyTransfer");
const AliMoneyTransactions = () => import("@/views/alimoney/AliMoneyTransactions");
const UserAliMoneyRequests = () => import("@/views/alimoney/UserAliMoneyRequests");

const UserAliMoneyTransactions = () => import("@/views/alimoney/UserAliMoneyTransactions");
const GoldStockEntry = () => import("@/views/alimoney/GoldStockEntry");

const ProductAdd = () => import("@/views/product/ProductAdd");
const ProductList = () => import("@/views/product/ProductList");

const Chat = () => import("@/views/chat/Chat");
const BulkPhotoPrinting = () => import("@/views/order-box/BulkPhotoPrinting");

const PageList = () => import("@/views/pages/PageList");
const PageAdd = () => import("@/views/pages/PageAdd");

const CampaignAdd = () => import("@/views/campaign/CampaignAdd");
const CampaignList = () => import("@/views/campaign/CampaignList");

const SliderAdd = () => import("@/views/slider/SliderAdd");
const SliderList = () => import("@/views/slider/SliderList");

const Statistics = () => import("@/views/statistics/Statistics");

const Notification = () => import("@/views/notification/NotificationSend");

const Options = () => import("@/views/option/Options");

const MenuAdd = () => import("@/views/menu/MenuAdd");
const MenuList = () => import("@/views/menu/MenuList");

const UserList = () => import("@/views/user/UserList");
const UserAdd = () => import("@/views/user/UserAdd");
const UserProfile = () => import("@/views/user/UserProfile");

const Login = () => import("@/views/user/Login");
const Page404 = () => import("@/views/errorPages/Page404");

const ChangePassword = () => import("@/views/user/ChangePassword");
const ResetPassword = () => import("@/views/user/ResetPassword");
const ChangeLanguage = () => import("@/views/user/ChangeLanguage");

const TokenList = () => import("@/views/token/TokenList");
const AddToken = () => import("@/views/token/AddToken");

const Album = () => import("@/views/user/Album");

const AccountTransactionList = () => import("@/views/account/AccountTransactionList");
const POSTransactionList = () => import("@/views/POS/POSTransactionList");
const PreciousMetalBuy = () => import("@/views/preciousMetal/Buy");
const PreciousMetalSell = () => import("@/views/preciousMetal/Sell");

const FxTransactionList = () => import("@/views/preciousMetal/FxTransactionList");

const IBAN = () => import("@/views/money-transfer/IBAN");
const Execute = () => import("@/views/money-transfer/Execute");

const Log = () => import("@/views/log/LogList");

const CategoryAdd = () => import("@/views/category/CategoryAdd");
const CategoryList = () => import("@/views/category/CategoryList");

Vue.use(Router);
Vue.mixin({
  beforeRouteEnter(to, from, next) {
    // ***************************************** Check is authenticated
    if (localStorage.token === undefined && !to.meta.isPublic) next("/login");
    // ***************************************** Check is authenticated
    if (to.meta.component === undefined) {
      next(true);
    } else {
      const component = to.meta.component.name;
      const action = to.meta.action;
      const authResult = Authorize.hasAuth(component, action);
      if (authResult) {
        next(authResult);
      } else {
        next("/dashboard");
      }
    }
  },
});
export default new Router({
  // https://router.vuejs.org/api/#mode
  mode: "hash",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: getTranslation("login"),
      component: Login,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/reset-password",
      name: getTranslation("resetPassword"),
      component: ResetPassword,
    },
    {
      path: "/album/:id",
      name: getTranslation("album"),
      component: Album,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "",
      redirect: "/login",
    },
    {
      path: "/public",
      redirect: "/public/bulk-photo-printing",
      name: "Public",
      component: PublicContainer,
      children: [
        {
          path: "/public/bulk-photo-printing",
          name: getTranslation("bulkPhotoPrinting"),
          component: BulkPhotoPrinting,
          meta: {
            isPublic: true,
          },
        },
      ],
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: getTranslation("home"),
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: getTranslation("home"),
          component: Dashboard,
        },
        {
          path: "/add-token",
          name: getTranslation("addToken"),
          component: AddToken,
        },
        {
          path: "tokens",
          name: getTranslation("tokens"),
          redirect: "/token-list",
          meta: {
            component: TokenList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/token-list",
              name: getTranslation("tokens"),
              meta: {
                component: TokenList,
                action: "list",
              },
              component: TokenList,
            },
            {
              path: "/token-add",
              name: getTranslation("addToken"),
              meta: {
                component: AddToken,
                action: "add",
              },
              component: AddToken,
            },
            {
              path: "/token-add/:id",
              name: getTranslation("addToken"),
              meta: {
                component: AddToken,
                action: "add",
              },
              component: AddToken,
            },
          ],
        },
        {
          path: "orders",
          name: getTranslation("orders"),
          redirect: "/order-list",
          meta: {
            component: OrderList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/order-list",
              name: getTranslation("orders"),
              meta: {
                component: OrderList,
                action: "list",
              },
              component: OrderList,
            },
            {
              path: "/order-detail/:id",
              name: getTranslation("orderDetail"),
              meta: {
                component: OrderDetail,
                action: "edit",
              },
              component: OrderDetail,
            },
            {
              path: "/order-add",
              name: getTranslation("orderDetail"),
              meta: {
                component: OrderAdd,
                action: "add",
              },
              component: OrderAdd,
            },
          ],
        },
        {
          path: "category",
          name: getTranslation("categoryManagement"),
          redirect: "/category-list",
          meta: {
            component: CategoryList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/category-add",
              name: getTranslation("newCategory"),
              meta: {
                component: CategoryList,
                action: "add",
              },
              component: CategoryAdd,
            },
            {
              path: "/category-add/:id",
              name: getTranslation("updateCategory"),
              meta: {
                component: CategoryList,
                action: "edit",
              },
              component: CategoryAdd,
            },
            {
              path: "/category-list",
              name: getTranslation("categories"),
              meta: {
                component: CategoryList,
                action: "list",
              },
              component: CategoryList,
            },
          ],
        },
        {
          path: "/cargo-tracking",
          name: getTranslation("cargoTracking"),
          meta: {
            component: CargoTracking,
            action: "list",
          },
          component: CargoTracking,
        },
        {
          path: "/daily-cargo",
          name: getTranslation("dailyCargo"),
          meta: {
            component: DailyCargo,
            action: "list",
          },
          component: DailyCargo,
        },
        {
          path: "/alimoney",
          name: getTranslation("alimoney"),
          redirect: "/alimoney",
          meta: {
            component: AliMoney,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/alimoney",
              name: getTranslation("alimoney"),
              meta: {
                component: AliMoney,
                action: "list",
              },
              component: AliMoney,
            },
            {
              path: "/manuel-money-transfer",
              name: getTranslation("aliMoneyTransactions"),
              meta: {
                component: ManuelMoneyTransfer,
                action: "add",
              },
              component: ManuelMoneyTransfer,
            },
            {
              path: "/manuel-money-transfer/:id",
              name: getTranslation("aliMoneyTransactions"),
              meta: {
                component: ManuelMoneyTransfer,
                action: "edit",
              },
              component: ManuelMoneyTransfer,
            },
            {
              path: "/user-ali-money-requests",
              name: getTranslation("aliMoneyRequests"),
              meta: {
                component: UserAliMoneyRequests,
                action: "list",
              },
              component: UserAliMoneyRequests,
            },
            {
              path: "/user-ali-money-requests/:id",
              name: getTranslation("aliMoneyRequests"),
              meta: {
                component: UserAliMoneyRequests,
                action: "list",
              },
              component: UserAliMoneyRequests,
            },
            {
              path: "/ali-money-transactions",
              name: getTranslation("aliMoneyTransactions"),
              meta: {
                component: AliMoneyTransactions,
                action: "list",
              },
              component: AliMoneyTransactions,
            },
            {
              path: "/user-ali-money-transactions/:id",
              name: getTranslation("aliMoneyTransactions"),
              meta: {
                component: UserAliMoneyTransactions,
                action: "list",
              },
              component: UserAliMoneyTransactions,
            },
            {
              path: "/gold-stock-entry",
              name: getTranslation("goldStockEntry"),
              meta: {
                component: GoldStockEntry,
                action: "edit",
              },
              component: GoldStockEntry,
            },
          ],
        },
        {
          path: "user",
          name: getTranslation("userManagement"),
          redirect: "/user-list",
          meta: {
            component: UserList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/user-add",
              name: getTranslation("newUser"),
              meta: {
                component: UserList,
                action: "add",
              },
              component: UserAdd,
            },
            {
              path: "/user-add/:id",
              name: getTranslation("updateUser"),
              meta: {
                component: UserList,
                action: "edit",
              },
              component: UserAdd,
            },
            {
              path: "/user-list",
              name: getTranslation("user"),
              meta: {
                component: UserList,
                action: "list",
              },
              component: UserList,
            }, {
              path: "/user-profile",
              name: getTranslation("userProfile"),
              meta: {
                component: UserProfile,
                action: "save",
              },
              component: UserProfile,
            },
          ],
        },
        {
          path: "product",
          name: getTranslation("productManagement"),
          redirect: "/product-list",
          meta: {
            component: ProductList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/product-list",
              name: getTranslation("productManagement"),
              meta: {
                component: ProductList,
                action: "list",
              },
              component: ProductList,
            },
            {
              path: "/product-add/:id",
              name: getTranslation("editProduct"),
              meta: {
                component: ProductAdd,
                action: "edit",
              },
              component: ProductAdd,
            },
            {
              path: "/product-add",
              name: getTranslation("newProduct"),
              meta: {
                component: ProductAdd,
                action: "add",
              },
              component: ProductAdd,
            },
          ],
        },
        {
          path: "/chat",
          name: getTranslation("aliChat"),
          meta: {
            component: Chat,
            action: "list",
          },
          component: Chat,
        },
        {
          path: "campaign",
          name: getTranslation("campaignManagement"),
          redirect: "/campaign-list",
          meta: {
            component: CampaignList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/campaign-list",
              name: getTranslation("campaignManagement"),
              meta: {
                component: CampaignList,
                action: "list",
              },
              component: CampaignList,
            },
            {
              path: "/campaign-add/:id",
              name: getTranslation("editCampaign"),
              meta: {
                component: CampaignAdd,
                action: "edit",
              },
              component: CampaignAdd,
            },
            {
              path: "/campaign-add",
              name: getTranslation("newCampaign"),
              meta: {
                component: CampaignAdd,
                action: "add",
              },
              component: CampaignAdd,
            },
          ],
        },
        {
          path: "slider",
          name: getTranslation("sliderManagement"),
          redirect: "/slider-list",
          meta: {
            component: SliderList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/slider-list",
              name: getTranslation("sliderManagement"),
              meta: {
                component: SliderList,
                action: "list",
              },
              component: SliderList,
            },
            {
              path: "/slider-add/:id",
              name: getTranslation("editSlider"),
              meta: {
                component: SliderAdd,
                action: "edit",
              },
              component: SliderAdd,
            },
            {
              path: "/slider-add",
              name: getTranslation("newSlider"),
              meta: {
                component: SliderAdd,
                action: "add",
              },
              component: SliderAdd,
            },
          ],
        },
        {
          path: "pages",
          name: getTranslation("pageManagement"),
          redirect: "/page-list",
          meta: {
            component: PageList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/page-add",
              name: getTranslation("newPage"),
              meta: {
                component: PageList,
                action: "add",
              },
              component: PageAdd,
            },
            {
              path: "/page-add/:id",
              name: getTranslation("updatePage"),
              meta: {
                component: PageList,
                action: "edit",
              },
              component: PageAdd,
            },
            {
              path: "/page-list",
              name: getTranslation("pages"),
              meta: {
                component: PageList,
                action: "list",
              },
              component: PageList,
            },
          ],
        },
        {
          path: "/statistics",
          name: getTranslation("statistics"),
          meta: {
            component: Statistics,
            action: "list",
          },
          component: Statistics,
        },
        {
          path: "/notification",
          name: getTranslation("notificationManagement"),
          meta: {
            component: Notification,
            action: "save",
          },
          component: Notification,
        },
        {
          path: "/options",
          name: getTranslation("options"),
          meta: {
            component: Options,
            action: "save",
          },
          component: Options,
        },
        {
          path: "menu",
          name: getTranslation("menuManagement"),
          redirect: "/menu-list",
          meta: {
            component: MenuList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/menu-add",
              name: getTranslation("newMenu"),
              meta: {
                component: MenuList,
                action: "add",
              },
              component: MenuAdd,
            },
            {
              path: "/menu-add/:id",
              name: getTranslation("updateMenu"),
              meta: {
                component: MenuList,
                action: "edit",
              },
              component: MenuAdd,
            },
            {
              path: "/menu-list",
              name: getTranslation("menu"),
              meta: {
                component: MenuList,
                action: "list",
              },
              component: MenuList,
            },
          ],
        },
        {
          path: "accountTransactions",
          name: getTranslation("accountTransactions"),
          redirect: "/account-transaction-list",
          meta: {
            component: AccountTransactionList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/account-transaction-list",
              name: getTranslation("accountTransactions"),
              meta: {
                component: AccountTransactionList,
                action: "list",
              },
              component: AccountTransactionList,
            },
          ],
        },
        {
          path: "posTranactions",
          name: getTranslation("posTranactions"),
          redirect: "/pos-transaction-list",
          meta: {
            component: POSTransactionList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/pos-transaction-list",
              name: getTranslation("posTranactions"),
              meta: {
                component: POSTransactionList,
                action: "list",
              },
              component: POSTransactionList,
            },
          ],
        },
        {
          path: "logs",
          name: getTranslation("logs"),
          redirect: "/log-list",
          meta: {
            component: Log,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/log-list",
              name: getTranslation("Logs"),
              meta: {
                component: Log,
                action: "list",
              },
              component: Log,
            },
          ],
        },
        {
          path: "fxTranactions",
          name: getTranslation("fxTranactions"),
          redirect: "/fx-transaction-list",
          meta: {
            component: FxTransactionList,
            action: "list",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/fx-transaction-list",
              name: getTranslation("fxTranactions"),
              meta: {
                component: FxTransactionList,
                action: "list",
              },
              component: FxTransactionList,
            },
          ],
        },
        {
          path: "preciousMetalBuy",
          name: getTranslation("preciousMetalBuy"),
          redirect: "/precious-metal-buy",
          meta: {
            component: PreciousMetalBuy,
            action: "add",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/precious-metal-buy",
              name: getTranslation("preciousMetalBuy"),
              meta: {
                component: PreciousMetalBuy,
                action: "add",
              },
              component: PreciousMetalBuy,
            },
          ],
        },
        {
          path: "preciousMetalSell",
          name: getTranslation("preciousMetalSell"),
          redirect: "/precious-metal-sell",
          meta: {
            component: PreciousMetalSell,
            action: "add",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/precious-metal-sell",
              name: getTranslation("preciousMetalSell"),
              meta: {
                component: PreciousMetalSell,
                action: "add",
              },
              component: PreciousMetalSell,
            },
          ],
        },
        {
          path: "IBAN",
          name: getTranslation("IBAN"),
          redirect: "/iban",
          meta: {
            component: IBAN,
            action: "add",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/iban",
              name: getTranslation("IBAN"),
              meta: {
                component: IBAN,
                action: "add",
              },
              component: IBAN,
            },
          ],
        },
        {
          path: "Execute",
          name: getTranslation("execute"),
          redirect: "/execute",
          meta: {
            component: Execute,
            action: "add",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "/execute",
              name: getTranslation("execute"),
              meta: {
                component: Execute,
                action: "add",
              },
              component: Execute,
            },
          ],
        },
        {
          path: "dashboard",
          redirect: "/",
          name: getTranslation("logs"),
          component: {
            render(c) {
              return c("router-view");
            },
          },
        },
        {
          path: "change-password",
          name: getTranslation("resetPassword"),
          component: ChangePassword,
        },
        {
          path: "change-language",
          name: getTranslation("changeLanguage"),
          component: ChangeLanguage,
        },
        {
          path: "*",
          name: getTranslation("pageNotFound"),
          component: Page404,
        },
      ],
    },
  ],

});
